module.exports = __webpack_public_path__ + "media/images/fairshare_logo-4458dca2a488f630ce25fc6a747214b0.png";